var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h17v17H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Component 16 \\u2013 1",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 163"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 73",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6",
  d: "m16.842 16.045-2.473-2.568a.564.564 0 0 0-.812.782l2.473 2.568a.564.564 0 0 0 .812-.782Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7",
  d: "M7.595-.004a7.481 7.481 0 1 0 7.594 7.481A7.546 7.546 0 0 0 7.595-.004Zm0 13.859a6.379 6.379 0 1 1 6.475-6.379 6.435 6.435 0 0 1-6.475 6.383Z"
}))))));
export default SvgSearchIcon;